import Alpine from "alpinejs";
import Clipboard from "@ryangjchandler/alpine-clipboard";
import intersect from "@alpinejs/intersect";
import DateRangePicker from "vanillajs-datepicker/DateRangePicker";
import Datepicker from "vanillajs-datepicker/Datepicker";
import it from "vanillajs-datepicker/locales/it";
Object.assign(Datepicker.locales, it);

window.DateRangePicker = DateRangePicker;

Alpine.plugin(Clipboard);
Alpine.plugin(intersect);
window.Alpine = Alpine;

require("fslightbox");

import Swiper, { Pagination, Autoplay, Thumbs } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

Swiper.use([Pagination, Autoplay, Thumbs]);
window.Swiper = Swiper;

import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-contrib-ads";
import "videojs-ima";
import "videojs-ima/dist/videojs.ima.css";
import 'videojs-logo';
import 'videojs-logo/dist/videojs-logo.css';

window.videojs = videojs;

// Remove due to conflict with fslightbox in photogallery section

// import "overlayscrollbars/overlayscrollbars.css";
// import { OverlayScrollbars } from "overlayscrollbars";
// window.OverlayScrollbars = OverlayScrollbars;

// document
//   .querySelectorAll("[data-overlayscrollbars-initialize]")
//   .forEach((elm) => {
//     OverlayScrollbars(elm, {
//       overflow: {
//         x: "hidden",
//       },
//     });
//   });

Alpine.start();
